import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import 'jquery-confirm';

export default function BasicProfile(props) {
    if (!props.profileData.hasOwnProperty('data')) return <></>;
    const { profile, dataValues } = props.profileData?.data ?? {};
    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Basic Profile</h4>
                </div>
            </CardHeader>
            <CardBody>
                <div className="row">
                    <div className="col s4 center-align">
                        <div style={{ textAlign: 'center' }}>
                            <img
                                src={profile?.imagePath ? `${process.env.REACT_APP_BASE_URL_API}${profile?.imagePath}` : "https://e7.pngegg.com/pngimages/507/702/png-clipart-profile-icon-simple-user-icon-icons-logos-emojis-users-thumbnail.png"}
                                alt="Profile"
                                className="circle responsive-img"
                                style={{ height: '250px', width: '250px' }}
                            />
                            <p className="flow-text">{profile?.firstName} {profile?.lastName}</p>
                        </div>
                    </div>
                    <div className="col s4">
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Email:</strong>
                            </div>
                            <div className="col s6">{dataValues?.email} </div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Mobile:</strong>
                            </div>
                            <div className="col s6">{dataValues?.phoneNumber}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Gender:</strong>
                            </div>
                            <div className="col s6">{profile?.gender}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Address Line 1:</strong>
                            </div>
                            <div className="col s6">{profile?.addressLine1}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Address Line 2:</strong>
                            </div>
                            <div className="col s6">{profile?.addressLine2}</div>
                        </div>
                    </div>
                    <div className="col s4">
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">DOB:</strong>
                            </div>
                            <div className="col s6">{profile?.dateOfBirth}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Country:</strong>
                            </div>
                            <div className="col s6">{profile?.country}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">City:</strong>
                            </div>
                            <div className="col s6">{profile?.city}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">State:</strong>
                            </div>
                            <div className="col s6">{profile?.state}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Pin Code:</strong>
                            </div>
                            <div className="col s6">{profile?.pinCode}</div>
                        </div>
                        <div className="row">
                            <div className="col s6">
                                <strong className="mb-3 d-block">Referral Source:</strong>
                            </div>
                            <div className="col s6">{profile?.referralSource}</div>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    )
}